var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GridCard',[_c('CataloguesCardHeader',{attrs:{"currentCatalogue":_vm.catalogue,"lang":_vm.lang}}),_c('CataloguesCardContent',{attrs:{"lines":_vm.catalogueLines}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }